module.exports = __webpack_public_path__ + "static/media/star-disable.87dd82dc.svg";